// HKDSE English Language Extended Mock Data
// 香港中學文憑考試 英國語文科 擴展模擬數據

export const hkdseEnglishExtended = [
  // English Language Paper 1 - Reading Comprehension
  {
    id: 21,
    name: 'HKDSE English Language Paper 1 (Reading)',
    nameEn: 'HKDSE English Language Paper 1 (Reading)',
    nameCn: 'HKDSE 英语 卷一 (阅读)',
    nameJa: 'HKDSE 英語 第一部 (読解)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English reading comprehension, vocabulary and language analysis skills',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the passage and answer: What is the main topic discussed?",
        questionEn: "Listen to the passage and answer: What is the main topic discussed?",
        hasAudio: true,
        audioUrl: "/audio/english/reading_passage_1.mp3",
        options: [
          "Climate change effects",
          "Renewable energy sources", 
          "Environmental conservation",
          "Global warming solutions"
        ],
        correctAnswer: 2,
        explanation: "The passage primarily discusses various methods of environmental conservation and their importance.",
        explanationEn: "The passage primarily discusses various methods of environmental conservation and their importance.",
        difficulty: "medium",
        topic: "Reading Comprehension"
      },
      {
        id: 2,
        question: "Which word best replaces 'ubiquitous' in the sentence: 'Smartphones have become ubiquitous in modern society'?",
        questionEn: "Which word best replaces 'ubiquitous' in the sentence: 'Smartphones have become ubiquitous in modern society'?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_context_1.mp3",
        options: ["rare", "expensive", "everywhere", "useful"],
        correctAnswer: 2,
        explanation: "'Ubiquitous' means present, appearing, or found everywhere. 'Everywhere' is the best synonym.",
        explanationEn: "'Ubiquitous' means present, appearing, or found everywhere. 'Everywhere' is the best synonym.",
        difficulty: "medium",
        topic: "Vocabulary"
      },
      {
        id: 3,
        question: "Listen to the conversation. What is the speaker's attitude towards the proposal?",
        questionEn: "Listen to the conversation. What is the speaker's attitude towards the proposal?",
        hasAudio: true,
        audioUrl: "/audio/english/attitude_analysis_1.mp3",
        options: ["Enthusiastic", "Skeptical", "Neutral", "Hostile"],
        correctAnswer: 1,
        explanation: "The speaker uses cautious language and raises concerns, indicating skepticism.",
        explanationEn: "The speaker uses cautious language and raises concerns, indicating skepticism.",
        difficulty: "hard",
        topic: "Attitude Analysis"
      },
      {
        id: 4,
        question: "In the sentence 'The committee's decision was unprecedented', what does 'unprecedented' mean?",
        questionEn: "In the sentence 'The committee's decision was unprecedented', what does 'unprecedented' mean?",
        hasAudio: true,
        audioUrl: "/audio/english/word_meaning_1.mp3",
        options: ["Never done before", "Very important", "Highly controversial", "Widely supported"],
        correctAnswer: 0,
        explanation: "'Unprecedented' means never done or known before, without previous example.",
        explanationEn: "'Unprecedented' means never done or known before, without previous example.",
        difficulty: "medium",
        topic: "Vocabulary"
      },
      {
        id: 5,
        question: "Listen to the news report. What is the main cause of the traffic disruption?",
        questionEn: "Listen to the news report. What is the main cause of the traffic disruption?",
        hasAudio: true,
        audioUrl: "/audio/english/news_report_1.mp3",
        options: ["Road construction", "Weather conditions", "Accident", "Public demonstration"],
        correctAnswer: 2,
        explanation: "The report clearly states that a multi-vehicle accident is causing the traffic delays.",
        explanationEn: "The report clearly states that a multi-vehicle accident is causing the traffic delays.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 6,
        question: "Read the passage: 'The phenomenon of urbanization has accelerated rapidly...' What does 'phenomenon' mean?",
        questionEn: "Read the passage: 'The phenomenon of urbanization has accelerated rapidly...' What does 'phenomenon' mean?",
        hasAudio: true,
        audioUrl: "/audio/english/reading_passage_2.mp3",
        options: ["Problem", "Observable event", "Solution", "Theory"],
        correctAnswer: 1,
        explanation: "A phenomenon is an observable event or occurrence that can be studied.",
        explanationEn: "A phenomenon is an observable event or occurrence that can be studied.",
        difficulty: "medium",
        topic: "Reading Comprehension"
      },
      {
        id: 7,
        question: "Listen to the dialogue. What is the relationship between the speakers?",
        questionEn: "Listen to the dialogue. What is the relationship between the speakers?",
        hasAudio: true,
        audioUrl: "/audio/english/dialogue_1.mp3",
        options: ["Teacher and student", "Doctor and patient", "Boss and employee", "Friends"],
        correctAnswer: 0,
        explanation: "The formal tone and educational content indicate a teacher-student relationship.",
        explanationEn: "The formal tone and educational content indicate a teacher-student relationship.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 8,
        question: "Which sentence uses the correct form of 'affect' or 'effect'?",
        questionEn: "Which sentence uses the correct form of 'affect' or 'effect'?",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_affect_effect.mp3",
        options: [
          "The rain will effect our plans.",
          "The rain will affect our plans.",
          "The affect of rain on our plans.",
          "Rain has no affect on plans."
        ],
        correctAnswer: 1,
        explanation: "'Affect' is a verb meaning to influence. 'Effect' is a noun meaning result.",
        explanationEn: "'Affect' is a verb meaning to influence. 'Effect' is a noun meaning result.",
        difficulty: "medium",
        topic: "Grammar"
      },
      {
        id: 9,
        question: "Listen to the scientific explanation. What is the main process described?",
        questionEn: "Listen to the scientific explanation. What is the main process described?",
        hasAudio: true,
        audioUrl: "/audio/english/science_process_1.mp3",
        options: ["Photosynthesis", "Cellular respiration", "DNA replication", "Protein synthesis"],
        correctAnswer: 0,
        explanation: "The explanation describes how plants convert sunlight into energy through photosynthesis.",
        explanationEn: "The explanation describes how plants convert sunlight into energy through photosynthesis.",
        difficulty: "hard",
        topic: "Scientific Listening"
      },
      {
        id: 10,
        question: "In the phrase 'a plethora of options', what does 'plethora' mean?",
        questionEn: "In the phrase 'a plethora of options', what does 'plethora' mean?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_plethora.mp3",
        options: ["Lack", "Abundance", "Variety", "Quality"],
        correctAnswer: 1,
        explanation: "'Plethora' means an abundance or large quantity of something.",
        explanationEn: "'Plethora' means an abundance or large quantity of something.",
        difficulty: "hard",
        topic: "Vocabulary"
      },
      {
        id: 11,
        question: "Listen to the weather forecast. What is predicted for tomorrow?",
        questionEn: "Listen to the weather forecast. What is predicted for tomorrow?",
        hasAudio: true,
        audioUrl: "/audio/english/weather_forecast_1.mp3",
        options: ["Sunny with clouds", "Heavy rain", "Snow", "Thunderstorms"],
        correctAnswer: 3,
        explanation: "The forecast clearly mentions thunderstorms expected tomorrow afternoon.",
        explanationEn: "The forecast clearly mentions thunderstorms expected tomorrow afternoon.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 12,
        question: "Which word is the antonym of 'ephemeral'?",
        questionEn: "Which word is the antonym of 'ephemeral'?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_ephemeral.mp3",
        options: ["Temporary", "Permanent", "Brief", "Fleeting"],
        correctAnswer: 1,
        explanation: "'Ephemeral' means lasting for a short time, so 'permanent' is its opposite.",
        explanationEn: "'Ephemeral' means lasting for a short time, so 'permanent' is its opposite.",
        difficulty: "hard",
        topic: "Vocabulary"
      },
      {
        id: 13,
        question: "Listen to the interview. What is the interviewee's main concern?",
        questionEn: "Listen to the interview. What is the interviewee's main concern?",
        hasAudio: true,
        audioUrl: "/audio/english/interview_concern_1.mp3",
        options: ["Job security", "Work-life balance", "Salary increase", "Career advancement"],
        correctAnswer: 1,
        explanation: "The interviewee repeatedly mentions the importance of maintaining work-life balance.",
        explanationEn: "The interviewee repeatedly mentions the importance of maintaining work-life balance.",
        difficulty: "medium",
        topic: "Listening Comprehension"
      },
      {
        id: 14,
        question: "Complete the sentence: 'The data _____ that our hypothesis was correct.'",
        questionEn: "Complete the sentence: 'The data _____ that our hypothesis was correct.'",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_data_verb.mp3",
        options: ["suggest", "suggests", "are suggesting", "have suggested"],
        correctAnswer: 1,
        explanation: "'Data' can be treated as singular or plural, but 'suggests' is more commonly used in formal writing.",
        explanationEn: "'Data' can be treated as singular or plural, but 'suggests' is more commonly used in formal writing.",
        difficulty: "medium",
        topic: "Grammar"
      },
      {
        id: 15,
        question: "Listen to the historical account. Which period is being described?",
        questionEn: "Listen to the historical account. Which period is being described?",
        hasAudio: true,
        audioUrl: "/audio/english/history_period_1.mp3",
        options: ["Medieval period", "Renaissance", "Industrial Revolution", "Modern era"],
        correctAnswer: 2,
        explanation: "The description of factories and mass production indicates the Industrial Revolution.",
        explanationEn: "The description of factories and mass production indicates the Industrial Revolution.",
        difficulty: "medium",
        topic: "Historical Listening"
      },
      {
        id: 16,
        question: "What is the meaning of 'serendipity'?",
        questionEn: "What is the meaning of 'serendipity'?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_serendipity.mp3",
        options: ["Bad luck", "Happy accident", "Careful planning", "Hard work"],
        correctAnswer: 1,
        explanation: "'Serendipity' means a pleasant surprise or happy accident.",
        explanationEn: "'Serendipity' means a pleasant surprise or happy accident.",
        difficulty: "hard",
        topic: "Vocabulary"
      },
      {
        id: 17,
        question: "Listen to the cooking instructions. What is the first step?",
        questionEn: "Listen to the cooking instructions. What is the first step?",
        hasAudio: true,
        audioUrl: "/audio/english/cooking_instructions_1.mp3",
        options: ["Heat the oil", "Chop the vegetables", "Preheat the oven", "Season the meat"],
        correctAnswer: 2,
        explanation: "The instructions clearly state to preheat the oven to 350°F as the first step.",
        explanationEn: "The instructions clearly state to preheat the oven to 350°F as the first step.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 18,
        question: "Which sentence is grammatically correct?",
        questionEn: "Which sentence is grammatically correct?",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_comparison.mp3",
        options: [
          "She is more taller than her sister.",
          "She is taller than her sister.",
          "She is most tall than her sister.",
          "She is more tall than her sister."
        ],
        correctAnswer: 1,
        explanation: "For one-syllable adjectives, use '-er' for comparisons, not 'more'.",
        explanationEn: "For one-syllable adjectives, use '-er' for comparisons, not 'more'.",
        difficulty: "easy",
        topic: "Grammar"
      },
      {
        id: 19,
        question: "Listen to the travel announcement. What gate should passengers go to?",
        questionEn: "Listen to the travel announcement. What gate should passengers go to?",
        hasAudio: true,
        audioUrl: "/audio/english/travel_announcement_1.mp3",
        options: ["Gate A12", "Gate B15", "Gate C8", "Gate D3"],
        correctAnswer: 1,
        explanation: "The announcement clearly states that passengers should proceed to Gate B15.",
        explanationEn: "The announcement clearly states that passengers should proceed to Gate B15.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 20,
        question: "What does 'pragmatic' mean?",
        questionEn: "What does 'pragmatic' mean?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_pragmatic.mp3",
        options: ["Idealistic", "Practical", "Theoretical", "Emotional"],
        correctAnswer: 1,
        explanation: "'Pragmatic' means dealing with things in a practical rather than idealistic way.",
        explanationEn: "'Pragmatic' means dealing with things in a practical rather than idealistic way.",
        difficulty: "medium",
        topic: "Vocabulary"
      },
      {
        id: 21,
        question: "Listen to the phone conversation. What time is the appointment?",
        questionEn: "Listen to the phone conversation. What time is the appointment?",
        hasAudio: true,
        audioUrl: "/audio/english/phone_appointment_1.mp3",
        options: ["2:30 PM", "3:00 PM", "3:30 PM", "4:00 PM"],
        correctAnswer: 2,
        explanation: "The caller confirms the appointment for 3:30 PM on Friday.",
        explanationEn: "The caller confirms the appointment for 3:30 PM on Friday.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 22,
        question: "Choose the correct passive voice form: 'The committee will review the proposal.'",
        questionEn: "Choose the correct passive voice form: 'The committee will review the proposal.'",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_passive_voice.mp3",
        options: [
          "The proposal will be reviewed by the committee.",
          "The proposal will reviewed by the committee.",
          "The proposal will being reviewed by the committee.",
          "The proposal will have reviewed by the committee."
        ],
        correctAnswer: 0,
        explanation: "Passive voice with 'will': subject + will + be + past participle.",
        explanationEn: "Passive voice with 'will': subject + will + be + past participle.",
        difficulty: "medium",
        topic: "Grammar"
      },
      {
        id: 23,
        question: "Listen to the museum guide. Which century does the artifact date from?",
        questionEn: "Listen to the museum guide. Which century does the artifact date from?",
        hasAudio: true,
        audioUrl: "/audio/english/museum_guide_1.mp3",
        options: ["15th century", "16th century", "17th century", "18th century"],
        correctAnswer: 1,
        explanation: "The guide mentions the artifact was created during the Renaissance, specifically the 16th century.",
        explanationEn: "The guide mentions the artifact was created during the Renaissance, specifically the 16th century.",
        difficulty: "medium",
        topic: "Historical Listening"
      },
      {
        id: 24,
        question: "What is the meaning of 'ambiguous'?",
        questionEn: "What is the meaning of 'ambiguous'?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_ambiguous.mp3",
        options: ["Clear", "Uncertain", "Obvious", "Simple"],
        correctAnswer: 1,
        explanation: "'Ambiguous' means having more than one possible meaning; unclear or uncertain.",
        explanationEn: "'Ambiguous' means having more than one possible meaning; unclear or uncertain.",
        difficulty: "medium",
        topic: "Vocabulary"
      },
      {
        id: 25,
        question: "Listen to the sports commentary. Which team is winning?",
        questionEn: "Listen to the sports commentary. Which team is winning?",
        hasAudio: true,
        audioUrl: "/audio/english/sports_commentary_1.mp3",
        options: ["Home team", "Away team", "It's tied", "Cannot determine"],
        correctAnswer: 0,
        explanation: "The commentator mentions the home team is leading by two points.",
        explanationEn: "The commentator mentions the home team is leading by two points.",
        difficulty: "easy",
        topic: "Listening Comprehension"
      },
      {
        id: 26,
        question: "Which sentence uses correct subject-verb agreement?",
        questionEn: "Which sentence uses correct subject-verb agreement?",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_subject_verb.mp3",
        options: [
          "Neither the students nor the teacher are ready.",
          "Neither the students nor the teacher is ready.",
          "Neither the student nor the teachers is ready.",
          "Neither the student nor the teachers are ready."
        ],
        correctAnswer: 1,
        explanation: "With 'neither...nor', the verb agrees with the subject closest to it ('teacher' is singular).",
        explanationEn: "With 'neither...nor', the verb agrees with the subject closest to it ('teacher' is singular).",
        difficulty: "hard",
        topic: "Grammar"
      },
      {
        id: 27,
        question: "Listen to the technology review. What is the main advantage mentioned?",
        questionEn: "Listen to the technology review. What is the main advantage mentioned?",
        hasAudio: true,
        audioUrl: "/audio/english/tech_review_1.mp3",
        options: ["Speed", "Cost", "User-friendliness", "Durability"],
        correctAnswer: 2,
        explanation: "The reviewer emphasizes how easy the technology is to use for beginners.",
        explanationEn: "The reviewer emphasizes how easy the technology is to use for beginners.",
        difficulty: "medium",
        topic: "Technology Listening"
      },
      {
        id: 28,
        question: "What does 'meticulous' mean?",
        questionEn: "What does 'meticulous' mean?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_meticulous.mp3",
        options: ["Careless", "Extremely careful", "Quick", "Lazy"],
        correctAnswer: 1,
        explanation: "'Meticulous' means showing great attention to detail; very careful and precise.",
        explanationEn: "'Meticulous' means showing great attention to detail; very careful and precise.",
        difficulty: "medium",
        topic: "Vocabulary"
      },
      {
        id: 29,
        question: "Listen to the environmental report. What is the main concern?",
        questionEn: "Listen to the environmental report. What is the main concern?",
        hasAudio: true,
        audioUrl: "/audio/english/environmental_report_1.mp3",
        options: ["Air pollution", "Water contamination", "Deforestation", "Climate change"],
        correctAnswer: 1,
        explanation: "The report focuses on contamination of local water sources from industrial waste.",
        explanationEn: "The report focuses on contamination of local water sources from industrial waste.",
        difficulty: "medium",
        topic: "Environmental Listening"
      },
      {
        id: 30,
        question: "Choose the sentence with correct punctuation:",
        questionEn: "Choose the sentence with correct punctuation:",
        hasAudio: true,
        audioUrl: "/audio/english/punctuation_rules.mp3",
        options: [
          "However, we decided to proceed with the plan.",
          "However we decided to proceed with the plan.",
          "However; we decided to proceed with the plan.",
          "However: we decided to proceed with the plan."
        ],
        correctAnswer: 0,
        explanation: "Transitional words like 'however' at the beginning of a sentence should be followed by a comma.",
        explanationEn: "Transitional words like 'however' at the beginning of a sentence should be followed by a comma.",
        difficulty: "easy",
        topic: "Punctuation"
      }
    ]
  },

  // English Language Paper 2 - Writing Skills
  {
    id: 22,
    name: 'HKDSE English Language Paper 2 (Writing)',
    nameEn: 'HKDSE English Language Paper 2 (Writing)',
    nameCn: 'HKDSE 英语 卷二 (写作)',
    nameJa: 'HKDSE 英語 第二部 (作文)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English writing skills, grammar usage and text organization',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Which sentence demonstrates correct parallel structure?",
        questionEn: "Which sentence demonstrates correct parallel structure?",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_parallel_1.mp3",
        options: [
          "She likes reading, writing, and to paint.",
          "She likes reading, writing, and painting.",
          "She likes to read, writing, and painting.",
          "She likes read, write, and paint."
        ],
        correctAnswer: 1,
        explanation: "Parallel structure requires all items in a series to have the same grammatical form. 'Reading, writing, and painting' are all gerunds.",
        explanationEn: "Parallel structure requires all items in a series to have the same grammatical form. 'Reading, writing, and painting' are all gerunds.",
        difficulty: "medium",
        topic: "Grammar"
      }
      // Additional questions would follow...
    ]
  },

  // English Language Paper 3 - Listening & Integrated Skills
  {
    id: 23,
    name: 'HKDSE English Language Paper 3 (Listening)',
    nameEn: 'HKDSE English Language Paper 3 (Listening)',
    nameCn: 'HKDSE 英语 卷三 (听力)',
    nameJa: 'HKDSE 英語 第三部 (聴解)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English listening comprehension and integrated language skills',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the academic lecture. What is the professor's main argument?",
        questionEn: "Listen to the academic lecture. What is the professor's main argument?",
        hasAudio: true,
        audioUrl: "/audio/english/academic_lecture_1.mp3",
        options: [
          "Technology improves education quality",
          "Traditional methods are more effective",
          "Blended learning is the optimal approach",
          "Online education has serious limitations"
        ],
        correctAnswer: 2,
        explanation: "The professor advocates for combining traditional and digital methods for optimal learning outcomes.",
        explanationEn: "The professor advocates for combining traditional and digital methods for optimal learning outcomes.",
        difficulty: "hard",
        topic: "Academic Listening"
      }
      // Additional questions would follow...
    ]
  },

  // English Language Paper 4 - Speaking Skills
  {
    id: 24,
    name: 'HKDSE English Language Paper 4 (Speaking)',
    nameEn: 'HKDSE English Language Paper 4 (Speaking)',
    nameCn: 'HKDSE 英语 卷四 (口语)',
    nameJa: 'HKDSE 英語 第四部 (会話)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English speaking skills, pronunciation and oral communication',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the pronunciation sample. Which word is pronounced correctly?",
        questionEn: "Listen to the pronunciation sample. Which word is pronounced correctly?",
        hasAudio: true,
        audioUrl: "/audio/english/pronunciation_sample_1.mp3",
        options: [
          "Colonel (/ˈkɜːrnəl/)",
          "Colonel (/ˈkɒlənəl/)",
          "Colonel (/ˈkoʊlənəl/)",
          "Colonel (/ˈkɔːlənəl/)"
        ],
        correctAnswer: 0,
        explanation: "'Colonel' is pronounced /ˈkɜːrnəl/, sounding like 'kernel'.",
        explanationEn: "'Colonel' is pronounced /ˈkɜːrnəl/, sounding like 'kernel'.",
        difficulty: "hard",
        topic: "Pronunciation"
      }
      // Additional questions would follow...
    ]
  },

  // English Language Paper 5 - Integrated Skills & Literature
  {
    id: 25,
    name: 'HKDSE English Language Paper 5 (Literature)',
    nameEn: 'HKDSE English Language Paper 5 (Literature)',
    nameCn: 'HKDSE 英语 卷五 (文学)',
    nameJa: 'HKDSE 英語 第五部 (文学)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English literature appreciation and critical analysis skills',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the poetry recitation. What literary device is primarily used?",
        questionEn: "Listen to the poetry recitation. What literary device is primarily used?",
        hasAudio: true,
        audioUrl: "/audio/english/poetry_recitation_1.mp3",
        options: ["Metaphor", "Alliteration", "Personification", "Symbolism"],
        correctAnswer: 1,
        explanation: "The poem uses repeated initial consonant sounds, which is alliteration.",
        explanationEn: "The poem uses repeated initial consonant sounds, which is alliteration.",
        difficulty: "medium",
        topic: "Literary Devices"
      }
      // Additional questions would follow...
    ]
  }
]; 